export default "__VITE_ASSET__ef0fb726__"